module.exports = __webpack_public_path__ + "img/step1.c6a20176.png";